import FieldValidationError from "./FieldValidationError";

const InputText = (props) => {
    return (
        <>
            <input
                type="text"
                className="form-control input-default"
                {...props}
            />
            <FieldValidationError error={props.error}/>
        </>
    );
}

export default InputText;